import { jwtDecode } from "jwt-decode";
import userService from "../api";
import productsService from "../../products/api";
import {
  DEL_CART_PRODUCT,
  DEL_CART,
  DEL_SHOWROOMS_PRODUCT,
  SELECT_ALL_ITEMS_CART,
  SELECT_ONE_ITEMS_CART,
  SET_ACTIVATED_EMAIL_MODAL,
  SET_AUTH,
  SET_BILLS_AMOUNT,
  SET_BILLS_LOADING,
  SET_CART_LIMIT_POPUP,
  SET_CART_LIMIT,
  SET_CART_LOADING,
  SET_CART_PRODUCT,
  SET_CART_PRODUCTS,
  SET_CART_SHOWROOMS_PRODUCTS,
  SET_CART,
  SET_CURRENT_USER,
  SET_DEVICE_TYPE,
  SET_FILTERS_STATUS,
  SET_GET_FREE_MODAL_SHOW,
  SET_SUBSCRIBE_MODAL_SHOW,
  SET_LOCALE,
  SET_LOGIN_MODAL_SHOW,
  SET_MOBILE_SCREEN,
  SET_NETWORK_STATUS,
  SET_PAID_PRODUCTS,
  SET_PAID_PROJECTS,
  SET_PAID_SUBSCRIBE,
  SET_USER_PAID_SUBSCRIBE,
  SET_PAYMENT_DATA,
  SET_PAYMENT_STATUS,
  SET_PRODUCT_INVOICE,
  SET_PUBLIC_STRIPE_TOKEN,
  SET_PURCHASES_LIMIT,
  SET_PURCHASES_LOADING,
  SET_RECOVERY_MODAL_SHOW,
  SET_RESULT_SEARCH,
  SET_SEARCH_PAGE,
  SET_SEARCH,
  SET_SERVER_ERROR,
  SET_SHOWROMS_PRODUCT,
  SET_SIGNUP_MODAL_SHOW,
  SET_TIP_AMOUNT,
  SET_USER_AVATAR,
  SET_USER_BILLS_DATA,
  SET_USER_LOADING,
  SET_USER,
  SET_VISIBLE_SUBFOOTER,
} from "./user.constants";
import { BASE_URL, ADMIN_ROUTES } from "@app/routes";
import { replaceTo } from "@lib/utils";
import {
  User,
  Snackbar,
  SimilarProductDTO,
  SubscribePaidDTO,
  projectInstance,
} from "@entities/dtos";
import { setAlertAC } from "@entities/notifications/model/notifications.actions";
import { setPaginationAmountAC } from '@entities/products/model/products.actions';
import { setProjectsPaginationAmountAC } from "@entities/projects/model/projects.actions";
import {
  setCartToSimilarProductsAC,
  setCartToActiveProductAC,
} from "@entities/product/model/product.actions";
import { usersSetSelectedUserAC } from "@entities/users/model/users.actions";

import { dateLib } from "@shared";

/*
 * get csrf token to cookeies
 * get tokens
 **/
export const userCheckAuthTC = () => {
  return async (dispatch) => {
    try {
      const resp = await userService.getTokenCsrf();

      if (!resp?.data) {
        return;
      }

      const data = resp.data;

      localStorage.setItem("_csrf", data.token);

      const response = await userService.checkAuth();
      const { accessToken, user } = response?.data || {};

      if (!accessToken) {
        return;
      }

      const user_jwt = jwtDecode(accessToken);
      user_jwt.notifications = user?.notifications;
      const usersDTO = new User(user_jwt);
      dispatch(userSetUserAC(usersDTO));
      localStorage.setItem("token", accessToken);
    } catch (error) {
      dispatch(setAuthAC(false));
      if (error.response) {
        const status = error.response.status;
        const errors = error?.response?.data?.errors || {};
        if (status === 400) {
          return dispatch(userSetServerErrorsAC(errors));
        }

        if (status !== 403) {
          console.log("[ERROR]", errors);
        }
      }
    } finally {
      dispatch(userGetShowromsProductsTC());
    }
  };
};

export const userLoginTC = (formData, hash) => {
  return async (dispatch) => {
    try {
      const localTime = dateLib.getDateQueryString(new Date());

      formData.local_time = localTime;

      const { data } = await userService.login(formData);

      const { user, accessToken } = data;

      const usersDTO = new User(user);

      dispatch(userSetUserAC(usersDTO));
      localStorage.setItem("token", accessToken);

      return usersDTO;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400) {
          const errors = error?.response?.data?.errors || {};
          dispatch(userSetServerErrorsAC(errors));
        }
      }
    }
  };
};

export const userLogoutTC = () => {
  return async (dispatch) => {
    if (window?.socket) window.socket.send("logout");
    await userService.logout();

    dispatch(userSetUserAC({}));
    dispatch(setAuthAC(false));
    dispatch(setCartAC([]));

    localStorage.removeItem("token");

    const location = window.location;
    const isAdminLocation = ADMIN_ROUTES.filter((item) =>
      location.pathname.includes(item.path.pathname),
    );

    if (isAdminLocation.length) {
      return (location.href = BASE_URL.pathname);
    }
    location.reload();
  };
};

export const userRecoveryPasswordTC = (formData) => {
  return async (dispatch) => {
    try {
      await userService.recoveryPassword(formData);
      return true;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400) {
          const errors = error?.response?.data?.errors || {};
          dispatch(userSetServerErrorsAC(errors));
        }
      }
    }
  };
};

export const userResetPasswordTC = (formData) => {
  return async (dispatch) => {
    try {
      await userService.resetPassword(formData);

      return true;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400) {
          const errors = error?.response?.data?.errors || {};
          dispatch(userSetServerErrorsAC(errors));
        }
      }
    }
  };
};

export const userUpdatePasswordTC = (formData, user) => {
  return async (dispatch) => {
    try {
      await userService.updatePassword(formData);

      const snackbar = new Snackbar({
        status: 200,
        message: (
          <div className="">
            <h5 className="snack__header">Password updated.</h5>
          </div>
        ),
      });
      dispatch(setAlertAC(snackbar));

      return true;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400) {
          const errors = error?.response?.data?.errors || {};
          dispatch(userSetServerErrorsAC(errors));
        }
      }
      const snackbar = new Snackbar({
        status: 500,
        message: (
          <div className="">
            <h5 className="snack__header">
              Password has not been updated! Try update your password again or
              contact technical support.
            </h5>
          </div>
        ),
      });
      dispatch(setAlertAC(snackbar));
      console.log("[ERROR]", error);
    }
  };
};

export const userSendActivationOnEmailTC = (userEmail) => {
  return async (dispatch) => {
    try {
      await userService.confirmEmail(userEmail);

      const snackbar = new Snackbar({
        status: 200,
        message: (
          <div className="">
            <h5 className="snack__header">
              A link to verify your account has been sent to the email address
              you provided.
            </h5>
          </div>
        ),
      });
      dispatch(setAlertAC(snackbar));

      return true;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400) {
          const errors = error?.response?.data?.errors || {};
          dispatch(userSetServerErrorsAC(errors));
        }
      }
    }
  };
};

export const userCreateUserTC = (user) => {
  return async (dispatch) => {
    try {
      return await userService.createUser(user);
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400 || status === 422) {
          const errors = error?.response?.data?.errors || {};
          dispatch(userSetServerErrorsAC(errors));
        }
      }
    }
  };
};

export const userGetUserTC = (id) => {
  return async (dispatch) => {
    try {
      const response = await userService.getUser(id);

      const user = response.data;
      const usersDTO = new User(user);

      dispatch(userSetCurrentUserAC(usersDTO));

      dispatch(usersSetSelectedUserAC(usersDTO.id));
    } catch (error) {
      console.log(`[ERROR] ${error}`);
    }
  };
};

export const userGetUserSubscribeTC = (id) => {
  return async (dispatch) => {
    try {
      const response = await userService.getUserSubscribe(id);

      const subscribe = response.data;
      const subscribeDTO = new SubscribePaidDTO(subscribe);

      dispatch(userSetUserPaidSubscribeAC(subscribeDTO));
    } catch (error) {
      console.log(`[ERROR] ${error}`);
    }
  };
};

export const userUpdateUserTC = (id, user) => {
  return async (dispatch) => {
    try {
      const data = await userService.updateUser(id, user);

      if (data.status === 200) {
        const snackbar = new Snackbar({
          status: 200,
          message: (
            <div className="">
              <h5 className="snack__header">User updated successfully.</h5>
            </div>
          ),
        });

        dispatch(setAlertAC(snackbar));
      }
    } catch (error) {
      console.log(`[ERROR] ${error}`);
    }
  };
};

export const userUpdateUserSettingsTC = (user) => {
  return async (dispatch) => {
    try {
      await userService.updateUserSettings(user);

      dispatch(userSetUserAC(user));

      const snackbar = new Snackbar({
        status: 200,
        message: (
          <div className="">
            <h5 className="snack__header">Profile updated successfully.</h5>
          </div>
        ),
      });

      dispatch(setAlertAC(snackbar));
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400) {
          const errors = error?.response?.data?.errors || {};
          dispatch(userSetServerErrorsAC(errors));
        }
      }
    }
  };
};

export const userUpdateUserSettingsCountryTC = (user) => {
  return async (dispatch) => {
    await userService.updateUserSettingsCountry(user);

    dispatch(userSetUserAC(user));
  };
};

export const userUpdateUserAvaTC = (avatar, user) => {
  return async (dispatch) => {
    return await userService.updateUserAva(avatar, user);
  };
};

export const userDeleteUserTC = (id) => {
  return async (dispatch) => {
    return await userService.deleteUser(id);
  };
};

export const userGetCartTC = (basketId) => {
  return async (dispatch) => {
    try {
      dispatch(setCartLoadingAC(true));
      const response = await userService.getCart(basketId);

      if (response?.status === 200) {
        const { basket } = response.data;

        if (!basket?.products) {
          return;
        }

        const corrected_rows = basket.products.map((item) => {
          const clearFormats = replaceTo(
            item.illustration_formats,
            "&quot;",
            '"',
          );
          item.illustration_formats = JSON.parse(clearFormats);

          return item;
        });

        const MAX_CART_CAPACITY = 50;
        if (corrected_rows.length >= MAX_CART_CAPACITY) {
          dispatch(setCartLimitAC(true));
        }

        dispatch(setCartAC(corrected_rows));
        dispatch(userSetProductsInCartAC({ flag: true, cart: corrected_rows }));
        dispatch(setProductInCartAC({ flag: true, cart: corrected_rows }));
        dispatch(
          userSetShowroomsProductsInCartAC({
            flag: true,
            cart: corrected_rows,
          }),
        );
      }
    } catch (error) {
      console.log(`[ERROR] ${error}`);
    } finally {
      dispatch(setCartLoadingAC(false));
    }
  };
};

export const userAddProductToCartTC = (product, callback) => {
  return async (dispatch, getState) => {
    const userData = getState()?.userData;

    if (!userData.isAuth && !userData.user.id) {
      return dispatch(userSetModalLoginShowAC(true));
    }

    const { user, cart = [] } = userData;

    const MAX_CART_CAPACITY = 50;

    if (cart.length >= MAX_CART_CAPACITY) {
      dispatch(setCartLimitAC(true));
      return dispatch(userSetCartLimitpopupAC(true));
    }

    await userService.addProductToCart(user.basketId, product.id);

    dispatch(userSetProductsInCartAC({ flag: true, cart: [product] }));
    const isProductAlreadyInCart = cart.find((item) => item.id === product.id);

    if (!isProductAlreadyInCart) {
      dispatch(setCartAC([...cart, product]));
      dispatch(setCartToActiveProductAC({ flag: true, productId: product.id }));
      dispatch(setCartToSimilarProductsAC({ flag: true, cart: [product] }));
      dispatch(
        userSetShowroomsProductsInCartAC({ flag: true, cart: [product] }),
      );
    }

    const snackbar = new Snackbar({
      status: 200,
      message: (
        <div className="">
          <h5 className="snack__header">Illustration was added to the cart</h5>
        </div>
      ),
    });

    dispatch(setAlertAC(snackbar));

    if (callback) {
      callback();
    }
  };
};

export const userDeleteProductFromCartTC = (cartId, productId) => {
  return async (dispatch) => {
    await userService.deleteProductFromCart(cartId, productId);

    dispatch(deleteProductInCartAC(productId));
    dispatch(deleteProductFromShowroomAC(productId));
    dispatch(setCartLimitAC(false));

    const snackbar = new Snackbar({
      status: 200,
      message: (
        <div className="">
          <h5 className="snack__header">
            Illustration was removed from the cart
          </h5>
        </div>
      ),
    });

    dispatch(setAlertAC(snackbar));
  };
};

export const userResetCartTC = (cartId) => {
  return async (dispatch) => {
    await userService.resetCart(cartId);

    dispatch(resetCartAC(cartId));
  };
};

export const userGetStripeSettingsTC = () => {
  return async (dispatch) => {
    const data = await userService.getPublickStripeSettings();

    if (!data) {
      return;
    }

    const publicToken = data?.data?.publicToken || null;
    dispatch(setStripePublicTokenAC(publicToken));
  };
};

export const userGetInvoiceTC = (body) => {
  return async (dispatch) => {
    dispatch(userSetUserPreloaderAC(true));
    try {
      const response = await userService.getInvoice(body);
      dispatch(userSetProductInvoiceAC(response.data));
    } catch (error) {
      console.log(`[ERROR] ${error}`);
      const snackbar = new Snackbar({
        status: 500,
        message: (
          <div className="">
            <h5 className="snack__header">
              Failed to retrieve invoice. Please refresh the page and try again.
            </h5>
          </div>
        ),
      });

      dispatch(setAlertAC(snackbar));
      dispatch(userSetServerErrorsAC([{ param: 500, msg: error }]));
    } finally {
      dispatch(userSetUserPreloaderAC(false));
    }
  };
};

export const userPayInvoiceTC = (userForm) => {
  return async (dispatch, getState) => {
    dispatch(userSetUserPreloaderAC(true));
    try {
      const userData = getState().userData;

      const { invoice, user, paymentData } = userData;
      const paymentMethod = await createPaymentIntentTC(user.email);

      const settings = {
        country: userForm.country,
        line1: userForm.address,
        postal_code: userForm.postCode,
        customerId: invoice.customer,
      };

      if (userForm.hasOwnProperty("company")) {
        settings["companyName"] = userForm.company;
      }

      if (userForm.hasOwnProperty("tax")) {
        settings["companyVat"] = userForm.tax;
      }

      if (userForm.hasOwnProperty("taxType")) {
        settings["taxType"] = userForm.taxType;
      }

      const options = {
        settings,
        type: paymentData.type,
        projectId: paymentData?.projectId,
        notificationId: paymentData?.notificationId,
        basketId: user.basketId,
        paymentMethodId: paymentMethod.id,
      };

      if (paymentData.type === "product") {
        delete options["projectId"];
        delete options["notificationId"];
      }

      const response = await userService.payInvoice(invoice.invoiceId, options);

      if (response?.status === 200) {
        dispatch(userSetPaymentsStatusAC("success"));
      } else {
        dispatch(userSetPaymentsStatusAC("false_server"));
      }
    } catch (error) {
      let errorMess = error?.response?.data?.message || error;

      if (error?.response) {
        const isStripe = error.response?.data?.errors[0]?.isStripeError;
        const status = error.response.status;

        if (isStripe) {
          errorMess = "Incorrect card information or insufficient funds.";
          dispatch(userSetPaymentsStatusAC("false_user"));
        }

        if (status === 422) {
          errorMess = "Invalid personal tax number format.";
        }

        if (status !== 422 && status !== 402) {
          dispatch(userSetPaymentsStatusAC("false_server"));
        }

        dispatch(userSetPaymentsStatusAC("false_user"));
      } else {
        dispatch(userSetPaymentsStatusAC("false_user"));
      }

      const snackbar = new Snackbar({
        status: 500,
        message: (
          <div className="">
            <h5 className="snack__header">Payment failed. {errorMess}</h5>
          </div>
        ),
      });
      dispatch(setAlertAC(snackbar));
      dispatch(userSetServerErrorsAC([{ msg: errorMess }]));

      console.log("[Error]", error);
    } finally {
      dispatch(userSetUserPreloaderAC(false));
    }
  };
};

export const createPaymentIntentTC = (email) => {
  return new Promise(async (resolve, reject) => {
    if (!window.PAYMENT_ELEMENT || !window.STRIPE) {
      return;
    }

    try {
      const option = {
        type: "card",
        card: window.PAYMENT_ELEMENT,
        billing_details: {
          email,
        },
      };

      const result = await window.STRIPE.createPaymentMethod(option);

      if (result?.error) {
        reject(result?.error?.message);
      }

      resolve(result.paymentMethod);
    } catch (e) {
      reject(e);
    }
  });
};

export const userGetUserBillsTC = (params) => {
  return async (dispatch) => {
    try {
      dispatch(userSetBillsLoadingAC(true));
      const data = await userService.getBills(params);

      let { rows, count } = data.data;

      if (!count) {
        count = 1;
      }

      dispatch(userSetUserBillsAC(rows));
      dispatch(userSetBillsPaginationAmountAC(count));
    } catch (error) {
      console.log("[ERROR]", error);
    } finally {
      dispatch(userSetBillsLoadingAC(false));
    }
  };
};

export const userSendJobFormTC = (formData) => {
  return async (dispatch) => {
    try {
      formData["full_name"] = `${formData.firstName} ${formData.lastName}`;
      delete formData["firstName"];
      delete formData["lastName"];

      const response = await userService.sendJobForm(formData);

      if (response.status === 200) {
        const snackbar = new Snackbar({
          status: 200,
          message: (
            <div className="">
              <h5 className="snack__header">Форма успешно отправлена</h5>
            </div>
          ),
        });
        dispatch(setAlertAC(snackbar));
        return true;
      }

      throw response;
    } catch (error) {
      const snackbar = new Snackbar({
        status: 500,
        message: (
          <div className="">
            <h5 className="snack__header">
              Ошибка отправки формы. Попробуй ещё раз или свяжись с поддержкой.
            </h5>
          </div>
        ),
      });
      dispatch(setAlertAC(snackbar));
      console.log(`[ERROR] ${error}`);
      return false;
    }
  };
};

export const userGetShowromsProductsTC = () => {
  return async (dispatch) => {
    const orderBy = "popular";
    const limit = 10;
    const page = 1;
    const scale = 1920;

    let request = `?orderBy=${orderBy}&limit=${limit}&page=${page}&scale=${scale}`;

    const response = await productsService.getRecommendedProducts(request);

    if (response?.status === 200) {
      const { rows } = response.data;
      const showroomsProducts = rows.map((item) => new SimilarProductDTO(item));

      return dispatch(setShowRoomsProductsAC(showroomsProducts));
    }

    return dispatch(setShowRoomsProductsAC([]));
  };
};

export const userGetPaidProductsTC = (options) => {
  return async (dispatch) => {
    try {
      dispatch(userSetPurchasesLoadingAC(true));
      const data = await userService.getPaidProducts(options);

      let { rows, count } = data.data;

      if (!count) {
        count = 1;
      }

      dispatch(userSetPaidProductsAC(rows));
      dispatch(setPaginationAmountAC(count));
    } catch (error) {
      console.log("[ERROR]", error);
    } finally {
      dispatch(userSetPurchasesLoadingAC(false));
    }
  };
};

export const userGetPaidProjectsTC = (options) => {
  return async (dispatch) => {
    try {
      const data = await userService.getPaidProjects(options);

      let { rows, count } = data.data;

      if (!count) {
        count = 1;
      }

      dispatch(
        setPaidProjectsAC(
          rows.map((proj) => projectInstance.create(proj, "userProject")),
        ),
      );
      dispatch(setProjectsPaginationAmountAC(count));
    } catch (error) {
      console.log("[ERROR]", error);
    }
  };
};

export const userGetPaidSubscribeTC = (options) => {
  return async (dispatch) => {
    try {
      dispatch(userSetPurchasesLoadingAC(true));
      const data = await userService.getPaidSubscribe(options);

      const subscribe = data?.data || {};

      const subscribePaidDTO = new SubscribePaidDTO(subscribe);

      dispatch(userSetPaidSubscribeAC(subscribePaidDTO));
    } catch (error) {
      console.log("[ERROR]", error);
    } finally {
      dispatch(userSetPurchasesLoadingAC(false));
    }
  };
};

export const userSendSubscribeFormTC = (formData) => {
  return async (dispatch) => {
    try {
      await userService.sendSubscribeForm(formData);

      const snackbar = new Snackbar({
        status: 250,
        duration: 5000,
        message: (
          <div className="">
            <h5 className="snack__header">
              You have successfully subscribed to our newsletter
            </h5>
            <div className="snack__text">
              Thank you for subscribing! Now you can receive amazing sets and
              inspiration from the FlowPik team every week.
            </div>
          </div>
        ),
      });

      dispatch(setAlertAC(snackbar));
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400) {
          const errors = error?.response?.data?.errors || {};
          return dispatch(userSetServerErrorsAC(errors));
        }
      }

      const snackbar = new Snackbar({
        status: 500,
        message: (
          <div className="">
            <h5 className="snack__header">Subscription error.</h5>
          </div>
        ),
      });
      dispatch(setAlertAC(snackbar));
      console.log(`[ERROR] ${error}`);
    }
  };
};

export const userCancelNotificationTC = (id) => {
  return async (dispatch) => {
    try {
      const response = await userService.cancelNotification(id);
    } catch (error) {
      console.log("[ERROR]", error);
    }
  };
};

// REDUSER
export const userSetModalGetFreeProductTC = (data) => {
  return async (dispatch, getState) => {
    const userData = getState()?.userData;

    if (!userData.isAuth && !userData.user.id) {
      return dispatch(userSetModalLoginShowAC(true));
    }

    if (userData.user?.isSubscribed === "banned") {
      const snackbar = new Snackbar({
        status: 500,
        message: (
          <div className="">
            <h5 className="snack__header">Your account has been banned.</h5>
          </div>
        ),
      });
      return dispatch(setAlertAC(snackbar));
    }

    if (
      userData.isAuth &&
      (!userData.user?.isSubscribed ||
        userData.user?.isSubscribed === "canceled") &&
      !data?.product?.isFree
    ) {
      return dispatch(userSetModalSubscribeShowAC(data));
    }

    dispatch(userSetModalGetFreeProductAC(data));
  };
};

export const setAuthAC = (isAuth) => {
  return {
    type: SET_AUTH,
    payload: isAuth,
  };
};

export const userSetUserAC = (user) => {
  return {
    type: SET_USER,
    payload: new User(user),
  };
};

export const userSetNetworkAC = (user) => {
  return {
    type: SET_NETWORK_STATUS,
    payload: user,
  };
};

export const userSetServerErrorsAC = (errors) => {
  return {
    type: SET_SERVER_ERROR,
    payload: errors,
  };
};

export const userSetSearchAC = (text) => {
  return {
    type: SET_SEARCH,
    payload: text,
  };
};

export const userSetResultSearchAC = (text) => {
  return {
    type: SET_RESULT_SEARCH,
    payload: text,
  };
};

export const setCartAC = (cartArray) => {
  return {
    type: SET_CART,
    payload: cartArray,
  };
};

export const userSelectAllItemsCartAC = (flag) => {
  return {
    type: SELECT_ALL_ITEMS_CART,
    payload: flag,
  };
};

export const userSelectOneItemsCartAC = (payload) => {
  return {
    type: SELECT_ONE_ITEMS_CART,
    payload,
  };
};

export const userSetProductsInCartAC = (payload) => {
  return {
    type: SET_CART_PRODUCTS,
    payload,
  };
};

export const userSetShowroomsProductsInCartAC = (payload) => {
  return {
    type: SET_CART_SHOWROOMS_PRODUCTS,
    payload,
  };
};

export const setProductInCartAC = (payload) => {
  return {
    type: SET_CART_PRODUCT,
    payload,
  };
};

export const userSetTipAmountAC = (payload) => {
  return {
    type: SET_TIP_AMOUNT,
    payload,
  };
};

export const setShowRoomsProductsAC = (payload) => {
  return {
    type: SET_SHOWROMS_PRODUCT,
    payload,
  };
};

export const deleteProductInCartAC = (productId) => {
  return {
    type: DEL_CART_PRODUCT,
    payload: productId,
  };
};

export const deleteProductFromShowroomAC = (productId) => {
  return {
    type: DEL_SHOWROOMS_PRODUCT,
    payload: productId,
  };
};

export const resetCartAC = (backetId) => {
  return {
    type: DEL_CART,
    payload: backetId,
  };
};

export const userSetCurrentUserAC = (data) => {
  return {
    type: SET_CURRENT_USER,
    payload: data,
  };
};

export const userSetCurrentUserAvatarAC = (file) => {
  return {
    type: SET_USER_AVATAR,
    payload: file,
  };
};

export const setStripePublicTokenAC = (data) => {
  return {
    type: SET_PUBLIC_STRIPE_TOKEN,
    payload: data,
  };
};

export const userSetProductInvoiceAC = (data) => {
  return {
    type: SET_PRODUCT_INVOICE,
    payload: data,
  };
};

export const userSetUserPreloaderAC = (data) => {
  return {
    type: SET_USER_LOADING,
    payload: data,
  };
};

export const userSetCartLimitpopupAC = (data) => {
  return {
    type: SET_CART_LIMIT_POPUP,
    payload: data,
  };
};

export const setCartLimitAC = (data) => {
  return {
    type: SET_CART_LIMIT,
    payload: data,
  };
};

export const userSetLocaleAC = (data) => {
  return {
    type: SET_LOCALE,
    payload: data,
  };
};

export const userSetPaymentsStatusAC = (data) => {
  return {
    type: SET_PAYMENT_STATUS,
    payload: data,
  };
};

export const userSetActivatedEmailShowAC = (data) => {
  return {
    type: SET_ACTIVATED_EMAIL_MODAL,
    payload: data,
  };
};

export const userSetPurchasesLimitAC = (data) => {
  return {
    type: SET_PURCHASES_LIMIT,
    payload: data,
  };
};

export const userSetModalLoginShowAC = (data) => {
  return {
    type: SET_LOGIN_MODAL_SHOW,
    payload: data,
  };
};

export const userSetModalSignupShowAC = (data) => {
  return {
    type: SET_SIGNUP_MODAL_SHOW,
    payload: data,
  };
};

export const userSetModalRecoveryShowAC = (data) => {
  return {
    type: SET_RECOVERY_MODAL_SHOW,
    payload: data,
  };
};

export const userSetModalSubscribeShowAC = (data) => {
  return {
    type: SET_SUBSCRIBE_MODAL_SHOW,
    payload: data,
  };
};

export const userSetPaymentDataAC = (data) => {
  return {
    type: SET_PAYMENT_DATA,
    payload: data,
  };
};

export const userSetUserBillsAC = (data) => {
  return {
    type: SET_USER_BILLS_DATA,
    payload: data,
  };
};

export const userSetBillsPaginationAmountAC = (data) => {
  return {
    type: SET_BILLS_AMOUNT,
    payload: data,
  };
};

export const userSetBillsLoadingAC = (data) => {
  return {
    type: SET_BILLS_LOADING,
    payload: data,
  };
};

export const setPaidProjectsAC = (projects) => {
  return {
    type: SET_PAID_PROJECTS,
    payload: projects,
  };
};

export const userSetPaidProductsAC = (products) => {
  return {
    type: SET_PAID_PRODUCTS,
    payload: products,
  };
};

export const userSetPaidSubscribeAC = (subscribe) => {
  return {
    type: SET_PAID_SUBSCRIBE,
    payload: subscribe,
  };
};

export const userSetUserPaidSubscribeAC = (subscribe) => {
  return {
    type: SET_USER_PAID_SUBSCRIBE,
    payload: subscribe,
  };
};

export const userSetPurchasesLoadingAC = (data) => {
  return {
    type: SET_PURCHASES_LOADING,
    payload: data,
  };
};

export const setCartLoadingAC = (data) => {
  return {
    type: SET_CART_LOADING,
    payload: data,
  };
};

export const userSetSearchPageAC = (payload) => {
  return {
    type: SET_SEARCH_PAGE,
    payload,
  };
};

export const userSetDeviceTypeAC = (data) => {
  return {
    type: SET_DEVICE_TYPE,
    payload: data,
  };
};

export const userSetIsMobileScreenViewAC = (data) => {
  return {
    type: SET_MOBILE_SCREEN,
    payload: data,
  };
};

export const userSetVisibleSubFooterAC = (data) => {
  return {
    type: SET_VISIBLE_SUBFOOTER,
    payload: data,
  };
};

export const userSetModalGetFreeProductAC = (data) => {
  return {
    type: SET_GET_FREE_MODAL_SHOW,
    payload: data,
  };
};

export const userSetFiltersStatusAC = (data) => {
  return {
    type: SET_FILTERS_STATUS,
    payload: data,
  };
};
